import { App } from 'config/setup';
import { type InitialData } from 'entries/base/interfaces/initial-data';

import { initializeBase } from './initialize-base';

export function initializeWithData(initialData: InitialData): void {
  initializeBase();
  App.start?.(initialData);
}
